module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/blank-layout/blank-layout.component.scss
// module id = ./src/app/containers/blank-layout/blank-layout.component.scss
// module chunks = main